import React, { useEffect, useContext, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext, API } from '@/App';
import { toast } from 'sonner';
import { Card, CardContent } from '@/components/ui/card';
import axios from 'axios';

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution
    if (hasProcessed.current) return;
    
    const token = searchParams.get('token');
    const provider = searchParams.get('provider');
    const error = searchParams.get('error');

    if (error) {
      hasProcessed.current = true;
      toast.error('Social login failed. Please try again or use email/password.');
      navigate('/', { replace: true });
      return;
    }

    if (token) {
      hasProcessed.current = true;
      
      // Fetch user data to update context
      const fetchUser = async () => {
        try {
          const response = await axios.get(`${API}/users/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          
          // Use login from AuthContext to properly set auth state
          login(token, response.data);
          
          toast.success(`✨ Welcome! You've successfully signed in with ${provider === 'google' ? 'Google' : 'LinkedIn'}.`);
          
          // Navigate using React Router instead of full page reload
          navigate('/dashboard', { replace: true });
        } catch (error) {
          console.error('Failed to fetch user:', error);
          toast.error('Failed to complete sign in. Please try again.');
          navigate('/', { replace: true });
        }
      };
      
      fetchUser();
    } else if (!hasProcessed.current) {
      hasProcessed.current = true;
      toast.error('Authentication failed. Please try again.');
      navigate('/', { replace: true });
    }
  }, [searchParams, navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: 'linear-gradient(135deg, #FFE5EC 0%, #FFF8F3 50%, #D4E7D9 100%)' }}>
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="text-center">
            <img src="/logo.png" alt="Her Enterprise Hub" className="h-20 w-auto mx-auto mb-4" />
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-rose-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Completing sign in...</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AuthCallback;
